import HomePage from "./Home";
export default HomePage;
export { default as HomePage } from './Home';